import { LinkFieldValue } from "@sitecore-jss/sitecore-jss-react/types/components/Link";
import { ImageField, StringField } from "../../../types/types";
import {
  CardModuleFullFields,
  CardModuleFullProps,
} from "../types/CardModuleFull.types";

export class CardModuleFullModel {
  private readonly fields?: CardModuleFullFields;
  constructor(props: CardModuleFullProps) {
    this.fields = props.fields || undefined;
  }
  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get image(): ImageField | undefined {
    return this.fields?.image;
  }

  get imageMobile(): ImageField | undefined {
    return this.fields?.ImageMobile;
  }

  get imageTitle(): ImageField | undefined {
    return this.fields?.ImageTitle;
  }

  get AllowFallbackForMobile(): boolean {
    return !!this.fields?.AllowFallbackForMobile?.value;
  }
  get primaryLink(): LinkFieldValue | undefined {
    return this.fields?.link1?.value;
  }

  get secondaryLink(): LinkFieldValue | undefined {
    return this.fields?.link2?.value;
  }

  get bodyText(): StringField | undefined {
    return this.fields?.bodyText;
  }

  get variant(): StringField | undefined {
    return this.fields?.Variant;
  }
}
